// extracted by mini-css-extract-plugin
module.exports = {"removeCol":"removeCol--2JKYT","singleTask":"singleTask--1pvMx","addNewCol":"addNewCol--2RJpg","taskDescription":"taskDescription--2bn8X"};